import { ObjectTools } from '../../../tools/object-tools';
import { Notification, NotificationType } from '../../../services/notification.service';
import { SolIcon } from '@sol/icons';

export interface SolNotificationItem {
  id: string;
  text: string;
  textParams: Record<string, any>;
  icon: SolIcon;
  actionText?: string;
  closeable: boolean;
  notificationClass: string;
  count: number;
}

export class SolNotificationsState {
  private constructor(public readonly notifications: SolNotificationItem[]) {}

  public static of(): SolNotificationsState {
    return new SolNotificationsState([]);
  }

  public withNotifications(notifications: Notification[]): SolNotificationsState {
    const mapped: SolNotificationItem[] = notifications
      .map(notification => ({
        id: notification.id,
        text: notification.text,
        textParams: notification.textParams,
        icon: SolNotificationsState.toIconForType(notification.type),
        actionText: notification.action?.text,
        closeable: notification.closeable,
        notificationClass: SolNotificationsState.toNotificationClass(notification),
        count: notification.count,
      }))
      .reverse();
    return this.copy({ notifications: mapped });
  }

  private static toIconForType(type: NotificationType): SolIcon {
    switch (type) {
      case 'info':
        return SolIcon.info;
      case 'success':
        return SolIcon.check;
      case 'warning':
        return SolIcon.error;
      case 'error':
        return SolIcon.error;
      default:
        return SolIcon.help;
    }
  }

  private static toNotificationClass(notification: Notification): string {
    const typeClassName = SolNotificationsState.toClassNameForType(notification.type);
    const closeableClassName = !notification.closedAt ? '' : ' sol-notification-closing';
    return `${typeClassName}${closeableClassName}`;
  }

  private static toClassNameForType(type: NotificationType): string {
    switch (type) {
      case 'info':
        return 'sol-notification-info';
      case 'success':
        return 'sol-notification-success';
      case 'warning':
        return 'sol-notification-warning';
      case 'error':
        return 'sol-notification-danger';
      default:
        return '';
    }
  }

  private copy(props: Partial<SolNotificationsState>): SolNotificationsState {
    return ObjectTools.copy<SolNotificationsState>(this, props);
  }
}
